import React, {useEffect} from 'react'
import { Container, Alert } from 'react-bootstrap'
import { FormattedMessage } from 'react-intl'
import { useLocaleMessages } from './useLocaleMessages'

const TranslatedMessage = ({ id }) => (
    <FormattedMessage id={id} />
);
const NotFoundAlert = () => <TranslatedMessage id="NotFoundAlert" />
const NotFoundP = () => <TranslatedMessage id="NotFoundP" />

const NotFoundPage = () => {
    const messages = useLocaleMessages();
    useEffect(() => {
      const titleText = messages['NotFoundPageTitle'];
      document.title = titleText

      const metaDescription = messages['NotFoundPageMeta'];
      const existingMetaTag = document.head.querySelector(`meta[name="description"]`)
      if (existingMetaTag) {
        existingMetaTag.setAttribute('content', metaDescription);
      } else {
        const newMetaTag = document.createElement('meta');
        newMetaTag.setAttribute('name', "description");
        newMetaTag.setAttribute('content', metaDescription);
        document.head.appendChild(newMetaTag);
      }
    },[messages])
    return (
    <Container>
        <Alert variant="danger">
            <Alert.Heading><NotFoundAlert/></Alert.Heading>
            <p><NotFoundP/></p>
        </Alert>
    </Container>
    )
}

export { NotFoundPage as default }